/**
 * Flash Sale Countdown Timer
 * 闪购倒计时功能
 *
 * 当商品元字段 shangou = 1 且库存 > 0 时显示倒计时
 * 倒计时基于 inventory_last_updated 元字段，总时间24小时
 * 倒计时结束或库存为0时，商品进入sold out状态
 */

(function() {
  'use strict';

  // 倒计时总时长（秒）- 24小时
  const FLASH_SALE_DURATION = 24 * 60 * 60; // 86400 seconds
  
  // 存储已初始化的倒计时，避免重复初始化
  const initializedCountdowns = new Set();

  /**
   * 初始化所有闪购倒计时
   */
  function initFlashSaleCountdowns() {
    const countdownElements = document.querySelectorAll('.flash-sale-countdown');
    
    countdownElements.forEach(function(element) {
      const elementId = element.id || element.getAttribute('data-section-id');
      
      // 避免重复初始化
      if (elementId && initializedCountdowns.has(elementId)) {
        return;
      }
      
      initCountdown(element);
      
      if (elementId) {
        initializedCountdowns.add(elementId);
      }
    });
  }

  /**
   * 初始化单个倒计时
   * @param {HTMLElement} element - 倒计时容器元素
   */
  function initCountdown(element) {
    const startTimeStr = element.getAttribute('data-start-time');
    const duration = parseInt(element.getAttribute('data-duration')) || FLASH_SALE_DURATION;
    const sectionId = element.getAttribute('data-section-id');
    const productId = element.getAttribute('data-product-id');
    
    if (!startTimeStr) {
      console.warn('Flash sale countdown: No start time provided');
      return;
    }

    // 解析开始时间 - 支持多种格式
    let startTime;
    try {
      // 尝试直接解析ISO格式
      startTime = new Date(startTimeStr).getTime();
      
      // 如果解析失败，尝试其他格式
      if (isNaN(startTime)) {
        // 尝试解析 Unix 时间戳（秒）
        const timestamp = parseInt(startTimeStr);
        if (!isNaN(timestamp)) {
          startTime = timestamp * 1000;
        }
      }
    } catch (e) {
      console.warn('Flash sale countdown: Error parsing start time', e);
      return;
    }
    
    if (isNaN(startTime)) {
      console.warn('Flash sale countdown: Invalid start time format:', startTimeStr);
      return;
    }

    // 计算结束时间
    const endTime = startTime + (duration * 1000);
    
    // 检查是否已经过期
    const now = Date.now();
    if (endTime <= now) {
      // 已经过期，直接显示sold out
      handleFlashSaleEnd(sectionId, productId);
      return;
    }
    
    // 获取倒计时显示元素
    const timerElement = element.querySelector('.countdown-timer');
    
    if (!timerElement) {
      console.warn('Flash sale countdown: Timer element not found');
      return;
    }

    // 立即更新一次显示
    updateCountdown(timerElement, endTime, sectionId, productId);
    
    // 每秒更新一次
    const intervalId = setInterval(function() {
      const shouldContinue = updateCountdown(timerElement, endTime, sectionId, productId);
      if (!shouldContinue) {
        clearInterval(intervalId);
      }
    }, 1000);

    // 存储interval ID以便后续清理
    element.setAttribute('data-interval-id', String(intervalId));
  }

  /**
   * 更新倒计时显示
   * @param {HTMLElement} timerElement - 显示时间的元素
   * @param {number} endTime - 结束时间戳（毫秒）
   * @param {string} sectionId - section ID
   * @param {string} productId - 产品 ID
   * @returns {boolean} - 是否继续倒计时
   */
  function updateCountdown(timerElement, endTime, sectionId, productId) {
    const now = Date.now();
    const remainingMs = endTime - now;
    
    if (remainingMs <= 0) {
      // 倒计时结束
      timerElement.textContent = '00:00:00';
      // 同步更新浮动按钮的倒计时显示
      syncFloatingCountdown('00:00:00');
      handleFlashSaleEnd(sectionId, productId);
      return false;
    }

    // 计算时、分、秒
    const totalSeconds = Math.floor(remainingMs / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    // 格式化显示
    const formattedTime =
      padZero(hours) + ':' +
      padZero(minutes) + ':' +
      padZero(seconds);
    
    timerElement.textContent = formattedTime;
    
    // 同步更新浮动按钮的倒计时显示
    syncFloatingCountdown(formattedTime);
    
    return true;
  }

  /**
   * 同步浮动按钮的倒计时显示
   * @param {string} formattedTime - 格式化的时间字符串
   */
  function syncFloatingCountdown(formattedTime) {
    const floatingCountdown = document.getElementById('floating-flash-sale-countdown');
    if (floatingCountdown) {
      const floatingTimer = floatingCountdown.querySelector('.countdown-timer');
      if (floatingTimer) {
        floatingTimer.textContent = formattedTime;
      }
    }
  }

  /**
   * 数字补零
   * @param {number} num - 数字
   * @returns {string} - 补零后的字符串
   */
  function padZero(num) {
    return num < 10 ? '0' + num : String(num);
  }

  /**
   * 处理闪购结束
   * @param {string} sectionId - section ID
   * @param {string} productId - 产品 ID
   */
  function handleFlashSaleEnd(sectionId, productId) {
    // 找到对应的提交按钮（主按钮）
    const submitButton = document.getElementById('ProductSubmitButton-' + sectionId);
    
    if (submitButton) {
      // 禁用按钮
      submitButton.disabled = true;
      
      // 更新按钮文字
      const buttonTextSpan = submitButton.querySelector('span:first-child');
      if (buttonTextSpan) {
        buttonTextSpan.textContent = 'Sold out';
      }
      
      // 隐藏倒计时文字
      const countdownElement = document.getElementById('flash-sale-countdown-' + sectionId);
      if (countdownElement) {
        countdownElement.style.display = 'none';
      }
      
      // 禁用表单中的隐藏输入
      const form = submitButton.closest('form');
      if (form) {
        const variantInput = form.querySelector('input[name="id"]');
        if (variantInput) {
          variantInput.disabled = true;
        }
      }
    }

    // 同时更新浮动按钮（如果存在）
    updateFloatingButtonSoldOut();

    // 触发自定义事件，以便其他脚本可以响应
    document.dispatchEvent(new CustomEvent('flashSaleEnded', {
      detail: {
        sectionId: sectionId,
        productId: productId
      }
    }));
  }

  /**
   * 更新浮动按钮为售罄状态
   */
  function updateFloatingButtonSoldOut() {
    const floatingButton = document.getElementById('floating-atc-button');
    if (floatingButton) {
      floatingButton.disabled = true;
      
      // 更新按钮文字
      const floatingButtonText = floatingButton.querySelector('.floating-atc__button-text');
      if (floatingButtonText) {
        floatingButtonText.textContent = 'Sold out';
      }
      
      // 隐藏浮动按钮的倒计时
      const floatingCountdown = document.getElementById('floating-flash-sale-countdown');
      if (floatingCountdown) {
        floatingCountdown.style.display = 'none';
      }
    }
  }

  /**
   * 清理所有倒计时
   */
  function cleanupCountdowns() {
    const countdownElements = document.querySelectorAll('.flash-sale-countdown');
    
    countdownElements.forEach(function(element) {
      const intervalId = element.getAttribute('data-interval-id');
      if (intervalId) {
        clearInterval(parseInt(intervalId));
      }
    });
  }

  // DOM加载完成后初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFlashSaleCountdowns);
  } else {
    initFlashSaleCountdowns();
  }

  // 监听Shopify的section渲染事件（用于主题编辑器）
  document.addEventListener('shopify:section:load', function(event) {
    initFlashSaleCountdowns();
  });

  // 监听变体切换事件
  document.addEventListener('variant:change', function(event) {
    // 重新初始化倒计时（如果需要）
    setTimeout(initFlashSaleCountdowns, 100);
  });

  // 页面卸载时清理
  window.addEventListener('beforeunload', cleanupCountdowns);

  // 暴露到全局以便调试
  window.FlashSaleCountdown = {
    init: initFlashSaleCountdowns,
    cleanup: cleanupCountdowns
  };

})();